import { writable } from "svelte/store";

const { subscribe, set } = writable({ gtmActive: false });

function setGtmActive(gtmActive: boolean): void {
  set({ gtmActive });
}

function selectAnswer(question: string, answer: string): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_select_answer",
    event_params: {
      question,
      answer,
    },
  });
}

function openEmailPopup(): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_open_email_popup",
  });
}

function sendAdviceEmail(): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_send_advice_email",
  });
}

function openUrl(type: string): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_open_url",
    event_params: {
      type,
    },
  });
}

function showAdvice(results): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_show_advice",
    event_params: results,
  });
}

function selectMattress(data: object): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_select_mattress",
    event_params: data
  });
}

function startQuestionnaire(): void {
  resetParams();

  window.dataLayer.push({
    event: "questionnaire_start",
  });
}

function resetParams(): void {
  window.dataLayer.push({ event_params: null });
}

export const googleTagManagerStore = {
  subscribe,
  setGtmActive,
  selectAnswer,
  showAdvice,
  openUrl,
  selectMattress,
  startQuestionnaire,
  sendAdviceEmail,
  openEmailPopup,
};
